<ion-grid class="keyboard-container">
  <!-- Top row: 1, 2, 3 -->
  <ion-row class="keyboard-row">
    @for (digit of digits[0]; track digit) {
      <ion-col size="4">
        <ion-button
          fill="outline"
          (click)="onDigitClick(digit)"
          [disabled]="disabled || isDigitDisabled"
          class="key-button"
        >
          {{ digit }}
        </ion-button>
      </ion-col>
    }
  </ion-row>
  <!-- Second row: 4, 5, 6 -->
  <ion-row class="keyboard-row">
    @for (digit of digits[1]; track digit) {
      <ion-col size="4">
        <ion-button
          fill="outline"
          (click)="onDigitClick(digit)"
          [disabled]="disabled || isDigitDisabled"
          class="key-button"
        >
          {{ digit }}
        </ion-button>
      </ion-col>
    }
  </ion-row>
  <!-- Third row: 7, 8, 9 -->
  <ion-row class="keyboard-row">
    @for (digit of digits[2]; track digit) {
      <ion-col size="4">
        <ion-button
          fill="outline"
          (click)="onDigitClick(digit)"
          [disabled]="disabled || isDigitDisabled"
          class="key-button"
        >
          {{ digit }}
        </ion-button>
      </ion-col>
    }
  </ion-row>
  <!-- Bottom row: 0 (2 columns) and backspace (1 column) -->
  <ion-row class="keyboard-row">
    <ion-col size="8">
      <ion-button
        fill="outline"
        (click)="onDigitClick(0)"
        [disabled]="disabled || isDigitDisabled"
        class="key-button"
      >
        0
      </ion-button>
    </ion-col>
    <ion-col size="4">
      <ion-button
        fill="outline"
        color="medium"
        (click)="onBackspaceClick()"
        [disabled]="disabled || isBackspaceDisabled"
        class="key-button key-button-backspace"
      >
        <ion-icon name="backspace" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
